import { Fragment, useContext } from "react";
import cn from "classnames";

import { DEFAULT_MODE_WIZARD, SAFE_MODE_WIZARD } from "shared/constants/wizard";

import { WizardStore } from "shared/context/WizardStoreContext";

import styles from "@platformAssets/components/Wizard.module.scss";

import { ReactComponent as StepCompletedIcon } from "assets/shared/img/step-completed.svg";

type StepProps = {
  isActive: boolean;
  isCompleted: boolean;
  number: number;
  title?: string;
};

type StepperProps = {
  mode: typeof SAFE_MODE_WIZARD | typeof DEFAULT_MODE_WIZARD;
};

const Step = ({ isActive, isCompleted, number, title }: StepProps) => {
  return (
    <div
      className={`${styles.step} ${isCompleted ? styles.completed : ""} ${isActive ? styles.active : ""}`}
    >
      <div className={styles.stepIcon}>
        {isCompleted ? <StepCompletedIcon /> : number}
      </div>

      {title && <div className={styles.stepTitle}>{title}</div>}
    </div>
  );
};

const WizardStepper = ({ mode }: StepperProps) => {
  const [wizardStore] = useContext(WizardStore);

  const stepper = wizardStore.stepper;
  const hasTitle = mode === DEFAULT_MODE_WIZARD;

  return (
    <div className={cn(styles.stepperContainer)}>
      {Object.values(stepper).map((step, index: number) => (
        <Fragment key={index}>
          <Step
            isCompleted={step.isCompleted}
            isActive={step.isActive}
            number={step.number}
            title={hasTitle ? step.title : undefined}
          />

          {index + 1 !== Object.values(stepper).length ? (
            <div
              className={`${styles.stepLine} ${step.isCompleted ? styles.completed : ""}`}
            />
          ) : null}
        </Fragment>
      ))}
    </div>
  );
};

export { WizardStepper };
